import { render, staticRenderFns } from "./MenuReportSales.vue?vue&type=template&id=bea19c82&scoped=true&"
import script from "./MenuReportSales.vue?vue&type=script&lang=js&"
export * from "./MenuReportSales.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportSales.vue?vue&type=style&index=0&id=bea19c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea19c82",
  null
  
)

export default component.exports